// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  -webkit-user-select: none;
          user-select: none;
}

.btn {
  font-size: 1.5rem;
  padding-right: 3rem;
  padding-left: 3rem;
}

.voltar-login {
  display: inline-block;
  font-size: 1.2rem;
  text-decoration: underline;
}

h6 {
  font-size: 1.2rem;
}

.widget-form {
  width: 100%;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.widget-input {
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 0.375rem;
}
.widget-ancor {
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: unset !important;
  color: rgba(33, 37, 41, 0.7137254902) !important;
  font-size: 0.8rem;
  margin-top: -1.3rem;
  transition: all 100ms ease-in-out;
}
.widget-ancor:hover {
  color: #218BC3 !important;
}

.arrow-back:hover:not(.clicked) {
  animation: shakeShake 0.6s;
}

@keyframes shakeShake {
  0%, 100% {
    transform: translateX(0);
  }
  33% {
    transform: translateX(-3px);
  }
  66% {
    transform: translateX(3px);
  }
}
.widget-login {
  padding: 20px;
}
.widget-login .abc-checkbox label {
  font-size: 1.1rem;
}

.widget-ancor {
  font-size: 1rem;
  font-weight: bold;
}

.widget-ancor.ladda-button:hover {
  background: unset !important;
  border-color: unset !important;
  box-shadow: unset !important;
  background-color: unset !important;
}

.ladda-button[data-loading] {
  background-color: unset !important;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.common-box .panel-body {
  padding: 30px 20px 60px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/email-confirmation/email-confirmation.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;UAAA,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAGI;EACI,WAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAGI;EACI,cAAA;EACA,aAAA;EACA,uBAAA;AADR;AAII;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,gDAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;AAFR;AAIQ;EACI,yBAAA;AAFZ;;AAOA;EACI,0BAAA;AAJJ;;AAOA;EACI;IACI,wBAAA;EAJN;EAME;IACI,2BAAA;EAJN;EAME;IACI,0BAAA;EAJN;AACF;AAOA;EACI,aAAA;AALJ;AAOI;EACI,iBAAA;AALR;;AASA;EACI,eAAA;EACA,iBAAA;AANJ;;AAUI;EACI,4BAAA;EACA,8BAAA;EACA,4BAAA;EACA,kCAAA;AAPR;;AAWA;EACI,kCAAA;AARJ;;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,mBAAA;AARJ;;AAWA;EACI,uBAAA;AARJ;;AAWA;EACI,sBAAA;AARJ;;AAWA;EACI,uBAAA;AARJ","sourcesContent":["label {\n    user-select: none;\n}\n\n.btn {\n    font-size: 1.5rem;\n    padding-right: 3rem;\n    padding-left: 3rem;\n}\n\n.voltar-login {\n    display: inline-block;\n    font-size: 1.2rem;\n    text-decoration: underline;\n}\n\nh6 {\n    font-size: 1.2rem;\n}\n\n.widget {\n    &-form {\n        width: 100%;\n        gap: 1rem;\n        margin-top: 1rem;\n        margin-bottom: 2rem;\n    }\n\n    &-input {\n        height: 3.5rem;\n        width: 3.5rem;\n        border-radius: 0.375rem\n    }\n\n    &-ancor {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-decoration: unset!important;\n        color: #212529b6!important;\n        font-size: 0.8rem;\n        margin-top: -1.3rem;\n        transition: all 100ms ease-in-out;\n\n        &:hover {\n            color: #218BC3 !important\n        }\n    }\n}\n\n.arrow-back:hover:not(.clicked) {\n    animation: shakeShake 0.6s;\n}\n\n@keyframes shakeShake {\n    0%, 100% {\n        transform: translateX(0);\n    }\n    33% {\n        transform: translateX(-3px);\n    }\n    66% {\n        transform: translateX(3px);\n    }\n}\n\n.widget-login {\n    padding: 20px;\n\n    .abc-checkbox label {\n        font-size: 1.1rem;\n    }\n}\n\n.widget-ancor {\n    font-size: 1rem;\n    font-weight: bold;\n}\n\n.widget-ancor.ladda-button {\n    &:hover {\n        background: unset!important;\n        border-color: unset!important;\n        box-shadow: unset!important;\n        background-color: unset!important;\n    }\n}\n\n.ladda-button[data-loading] {\n    background-color: unset!important;\n}\n\n.d-flex {\n    display: flex;\n}\n\n.align-items-center {\n    align-items: center;\n}\n\n.justify-content-center {\n    justify-content: center;\n}\n\n.flex-column {\n    flex-direction: column;\n}\n\n.common-box .panel-body {\n    padding: 30px 20px 60px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
